<template>
  <div class="tag" :class="classNames" @click="click">
    <div v-if="creatingNew">
      <form class="tag-add-form" v-on:submit.prevent="save">
        <input class="tag-add-form-input" v-model="newTitle"/>
      </form>
      <div class="tag-add-btn" @click.stop="save">save</div>
      <div class="tag-add-btn" @click.stop="cancel">cancel</div>
    </div>
    <div v-else>
      {{title}}
      <font-awesome-icon class="tag-icon" icon="times" v-show="!create&&!isReserved" @click="$emit('delete')"/>
      <font-awesome-icon class="tag-icon" icon="wrench" v-show="isManual"/>
    </div>
  </div>

</template>

<!-- <style scoped> -->
<style>
.tag {
  display: inline-block;
  color: white;
  background-color: #333;
  /*border: 1px solid #cccccc;*/
  font-size: 10px;
  font-weight: bold;
  margin-left: 3px;
  padding-left: 2px;
  padding-right: 2px;
  border-radius: 3px;
}
.tag-btn {
  display: inline-block;
  cursor: pointer;
  color: #2c3e50;
  background-color: white;
  border: 1px solid #cccccc;
}
.tag-btn:active { 
  background-color: #eeeeee;
}
.tag-icon {
  margin-bottom: -1px;
}
.tag-add-form {
  display: inline;
}
.tag-add-form-input {
  height: 12px;
  padding: 0px;
  border-width: 0px;
}
.tag-add-btn {
  display: inline;
  cursor: pointer;
  border-left: 1px solid #cccccc;
}
.tag-remove-icon {
  display: inline;
  cursor: pointer;
}
.tag-severityhigh {
  cursor: pointer;
  background-color: #ff3333;
}
.tag-severitymedium {
  cursor: pointer;
  background-color: #ff9933;
}
.tag-severitylow {
  cursor: pointer;
  background-color: #ffcc33;
}
.tag-lowrelevance {
  cursor: pointer;
  background-color: #99ff33;
  color: #333;
}
.tag-falsepositive {
  cursor: pointer;
  background-color: #99ff33;
  color: #333;
}
.tag-sensitivedisclosure,
.tag-discussions,
.tag-blackmarkets,
.tag-financialinformation,
.tag-exposedcredentials,
.tag-personalinformation,
.tag-hackergrouptargeting,
.tag-attacksandcompromises {
  cursor: pointer;
  background-color: #3399ff;
}
.tag-unidentified {
  cursor: pointer;
  background-color: #3399ff;
  /*background-color: #cc33ff;*/
}
.tag-deepweb,
.tag-darkweb,
.tag-databreach {
    background-color: #993399;
}
</style>

<script>

import tags from '@/assets/tags'

export default {
  name: 'AlertTag',
  props: {
    title: {
      type: String,
      required: true
    },
    manual: {
      type: Boolean
    },
    create: {
      type: Boolean
    }
  },
  computed: {
    classNames () {
      if (this.create) return 'tag-btn'
      return ['tag-' + this.title]
    },
    isReserved () {
      if (tags.reserved.includes(this.title)) return true
      return false
    },
    isManual () {
      return this.manual
    }
  },
  methods: {
    click () {
      // console.log('Click <' + this.title + '>')
      if (this.create) {
        this.creatingNew = true
        return
      }
      // Emit click if severity or category is clicked, for now...
      if (tags.severity.includes(this.title) || tags.category.includes(this.title)) {
        this.$emit('click', this.title)
      }
    },
    save () {
      // console.log('Save <' + this.newTitle + '>')
      if (!this.newTitle) return
      if (tags.reserved.includes(this.newTitle)){
        alert('Unable to add reserved tag')
        return
      }
      this.$emit('create', this.newTitle)
      this.newTitle = ''
      this.creatingNew = false
    },
    cancel () {
      // console.log('Cancel <' + this.newTitle + '>')
      this.creatingNew = false
    }
  },
  data () {
    return {
      newTitle: '',
      creatingNew: false
    }
  },
}
</script>
